import React, { useEffect } from 'react';
import InnerHTML from 'dangerously-set-html-content';
import { PluginProps } from '../Plugin';

const HtmlBlock = (props: PluginProps) => {
  const { content } = props;

  const html = content?.data?.html;
  const cleanUpScript = content?.data?.clean_up_script;
  
  useEffect(() => {
    return () => {
      if (cleanUpScript)
        // eslint-disable-next-line no-eval
        eval(cleanUpScript);
    }
  }, [])

  if (!html) {
    return null;
  }


  return <InnerHTML html={html} />;
};

export default HtmlBlock;
